const video = () => {
  $('.js-video-btn').each((_, el) => {
    $(el).on('click', event => {
      event.preventDefault();

      $('html, body').css({
        overflow: 'hidden'
      });

      $(el).parent().append(`
        <div class="video-modal" style="display:none">
          <div class="video-modal__inner">
            <iframe
              src="${$(el).data('src')}"
              allow="autoplay"
              frameborder="0"
              allowfullscreen
            />
          </div>
        </div>
      `);

      const $modal = $(el).parent().find('.video-modal');

      $modal.one('click', () => {
        $('html, body').css({
          overflow: 'auto'
        });
        $modal.fadeOut(() => {
          $modal.remove();
        });
      });
      $modal.fadeIn();
    });
  });
};

export default video;
